module.exports = __webpack_public_path__ + "img/tx4.3d3e9254.png";